import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import {Button} from "reactstrap";
import {Card, CardContent, CardActions, Tooltip} from '@material-ui/core'

const {UniversalModal} = Framework.Elements;

import API from "@beardeddevops/react.api";
import ReactToPrint from 'react-to-print';
import APPCONFIG from "../../constants/Config";
import {Objects} from "../index";
import QuickCheckoutFavoriteStar from "../Parts/QuickCheckoutFavoriteStar";

export default class SkuObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Skus._name);
		// this.state.sku_auto = "";
		//
		// this.sku_request_complete = false;
		this.state.taxable = true;
		this.state.requireAmmoready = this.props.requireAmmoready ?? false;
	}

	loadSelfAfter(data) {
		const inventory = data.inventoriess && data.inventoriess[0];
		if (inventory && inventory.pkey != null && inventory.pkey !== '') {
			this.setState({
				linkedInventoryPkey: inventory.pkey,
				linkedInventoryQuantity: inventory.quantity,
			});
			if (typeof this.props.updateInventory === 'function') {
				this.props.updateInventory(inventory.pkey);
			}
		}
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.ammoready_inv !== prevState.ammoready_inv && this.state.ammoready_inventory) {
			const {name, price, description, sku, quantity} = this.state.ammoready_inventory;
			this.setState({name, price_retail: price, description, sku, quantity_current: quantity})
		}
	}


	// handleProcess = event => {
	// 	if (event == null || event.target.name === "sku") {
	// 		if (this.state.sku === "" && this.state.sku_auto !== "") {
	// 			this.state.sku = this.state.sku_auto;
	// 			this.state.sku_auto = "";
	// 		}
	// 	}
	// 	return API.Validator.process(this, this.requestType, true, event ? event.target.name : null);
	// };

	handleAfterSave = (event) => {
		this.setState({class: event.pkey});
	}

	form = () => {
		// let exists = this.state.pkey && this.state.pkey;
		/**
		 *  @param {Skus_Properties} data
		 */
		let {properties} = this.model;
		/**
		 *  @type {Skus_Object} object
		 */
		let object = this.state;
		let {loading} = this.state
		const inventoryRow = object.inventoriess && object.inventoriess[0];
		const inventoryPkey = this.props.inventoryPkey
			|| (inventoryRow && inventoryRow.pkey)
			|| object.linkedInventoryPkey;
		const inventoryQuantity = inventoryRow
			? (parseInt(inventoryRow.quantity, 10) || 0)
			: (parseInt(object.linkedInventoryQuantity, 10) || 0)
			|| (parseInt(object.quantity_current, 10) || 0);
		const isSerialized = object.serialized === true || object.serialized === 1 || object.serialized === '1';
		const canFavoriteInventory = !!inventoryPkey
			&& inventoryQuantity > 0
			&& !isSerialized;
		const favoriteDisabledReason = !inventoryPkey
			? 'Save this item before adding it to Quick Checkout favorites.'
			: isSerialized
				? 'Serialized items cannot be Quick Checkout favorites.'
				: inventoryQuantity <= 0
					? 'Only in-stock items can be Quick Checkout favorites.'
					: '';

		return (
			<div>
				{this.state.requireAmmoready === true && <>
					<h4 className="section-title">AmmoReady Item</h4>
					<b>You must select an AmmoReady item to link. If you do not see the item you want, make sure it exists in AmmoReady and has been Synced.</b>
					<div className={'form-group'} style={{paddingTop: 10}}>
						<Framework.Elements.Select
							shouldLoad={this.state.loaded}
							object={object.ammoready_inventory}
							nullable={true}
							value={object.ammoready_inv}
							error={object.ammoready_inv_error}
							model={Types.Ammoready_Inventory._name}
							property={properties.ammoready_inv}
							label={'AmmoReady Item'}
							update={this.handleSelectPropertyUpdate}
							requestOverride={'GET_UNLINKED'}
							textHelper={'description'}
						/>
					</div>
				</>}
				{(this.state.requireAmmoready === false || this.state.ammoready_inv) && (
					<h4 className="section-title">
						Inventory
						<QuickCheckoutFavoriteStar
							entityType="inventory"
							entityPkey={inventoryPkey}
							disabled={!canFavoriteInventory}
							disabledReason={favoriteDisabledReason}
						/>
					</h4>
				)}

				{(this.state.requireAmmoready === false || this.state.ammoready_inv) && <div className={"row"}>
					<div className={"col-md"}>
						<div className="form-group">
							<Framework.Elements.TextField
								name={"name"}
								label={"Name"}
								value={object.name}
								error={object.name_error}
								property={properties.name}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className="form-group">
							<Framework.Elements.TextField
								name={"sku"}
								label={"SKU"}
								value={object.sku}
								error={object.sku_error}
								property={properties.sku}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className="form-group">
							<div className="row">
								<div className="col d-flex">
									<Button data-id="add-sku" onClick={this.toggle('modalAdd')} size={"sm"} outline
									        color="success" className={"select-add"}>
										<i className={"fa fa-plus"}/>
									</Button>
									<div style={{width: "100%"}}>
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											property={properties.class}
											value={object.class}
											error={object.class_error}
											model={Types.Skus_Classes._name}
											nullable={false}
											limit={null}
										/>

										<UniversalModal
											isDev={APPCONFIG.settings.isDev()}
											locations={this.props.locations}
											name={"Inventory Group"}
											object={Objects.SkuClass}
											history={this.props.history}
											toggle={this.state['modalAdd']}
											reportClose={this.reportClose('modalAdd')}
											afterSave={this.handleAfterSave}
											size={'lg'}
											project={'pos'}
										/>

									</div>
								</div>
							</div>
						</div>
						<div className="form-group">
							<Framework.Elements.Select
								shouldLoad={true}
								update={this.handleSelectPropertyUpdate}
								property={properties.location}
								value={object.location}
								error={object.location_error}
								model={Types.Locations._name}
								nullable={false}
								limit={null}
							/>
						</div>
						<div className={'row'} style={{justifyContent: "space-between"}}>
							<div className={'col-6'}>
								<div className={'form-group'}>
									<Framework.Elements.ButtonSwitch
										value={!!object.taxable}
										error={object.taxable_error}
										property={properties.taxable}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={"Taxable"}
										labelFalse={"Non-Taxable"}
										project={'pos'}
									/>
								</div>
							</div>
							{object.ammoready_inv && object.pkey &&
								<div className={'col-6'} style={{display: 'flex', justifyContent: 'end'}}>
									<Tooltip title={"Inventory Sync Behavior"}>
										<div className={'form-group'}>
											<Framework.Elements.ButtonSwitch
												value={!!object.should_sync}
												error={object.should_sync_error}
												property={properties.should_sync}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"Sync to AmmoReady"}
												labelFalse={"Separate Inventory"}
												project={'pos'}
											/>
										</div>
									</Tooltip>
								</div>
							}
						</div>
						{object.class.value !== 0 ? null :
							<div className="form-group">
								<Framework.Elements.TextField
									name={"class_other"}
									label={"New Group"}
									value={object.class_other}
									error={object.class_other_error}
									property={properties.class_other}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						}
					</div>
					<div className={"col-md"}>
						<div className={"row"}>
							<div className="col-md">
								<div className="form-group">
									<Framework.Elements.DollarAmount
										size={"small"}
										name={"price_retail"}
										label={"Retail Price"}
										value={object.price_retail}
										error={object.price_retail_error}
										property={properties.price_retail}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className="col-md">
								<div className="form-group">
									<Framework.Elements.DollarAmount
										size={"small"}
										name={"price_minimum"}
										label={"Min Sale Price"}
										value={object.price_minimum}
										error={object.price_minimum_error}
										property={properties.price_minimum}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className="col-md">
								<div className="form-group">
									<Framework.Elements.DollarAmount
										size={"small"}
										name={"price_purchase"}
										label={"Purchase Price"}
										value={object.price_purchase}
										error={object.price_purchase_error}
										property={properties.price_purchase}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>
						<div className="form-group">
							<Framework.Elements.TextField
								name={"description"}
								label={"Description"}
								value={object.description}
								error={object.description_error}
								property={properties.description}
								update={this.handleTextFieldPropertyUpdate}
								multiline={6}
							/>
						</div>
					</div>
				</div>
				}
				<hr/>
				{(this.state.requireAmmoready === false || this.state.ammoready_inv) && <div className={"row"}>
					{!object.pkey ?
						<div className="col-md">
							<div className={"form-group"}>
								<strong>Stocking Levels</strong>
							</div>

							<div className="form-group">
								<Framework.Elements.NumberField
									name={"quantity_current"}
									label={"Current Stock *"}
									value={object.quantity_current}
									error={object.quantity_current_error}
									property={properties.quantity_current}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div> : null}
					<div className="col-md">
						<div className="col-md">
							<div className={"form-group"}>
								<strong>For Inventory Reporting (To Keep In Stock)</strong>
							</div>
						</div>

						<div className={'row'}>
							<div className={'col-md'}>
								<div className="form-group">
									<Framework.Elements.NumberField
										name={"quantity_min"}
										label={"Minimum"}
										value={object.quantity_min}
										error={object.quantity_min_error}
										property={properties.quantity_min}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>

							<div className={'col-md'}>
								<div className="form-group">
									<Framework.Elements.NumberField
										name={"quantity_max"}
										label={"Maximum"}
										value={object.quantity_max}
										error={object.quantity_max_error}
										property={properties.quantity_max}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>}


				{object.pkey && object.pkey ?
					<Framework.Printable.Label ref={el => (this['printable'] = el)} prefix="I" code={object.pkey}
					                           label={object.sku + "\n $" + object.price_retail}/> : null}

				<div className={classNames("loader", {'active': loading})}>
					<ClipLoader color={"#4A4A4A"} loading={loading}/>
				</div>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					<ReactToPrint
						trigger={() =>
							<Button className="secondary-button" style={{marginRight: 'auto'}}>Print Label</Button>
						}
						content={() => this['printable']}
						copyStyles={false}
						pageStyle={'@media print { body { -webkit-print-color-adjust: exact; margin: 0 } @page { margin: 0 }}'}
						bodyClass={""}
					/>
					{this.state.ammoready_inv && <Button color="warning" onClick={async () => {
						const ammoready_inv_model = new API.BuildClass(Types.Skus._name, 'DELETE')
						await ammoready_inv_model.submit(this, 'DELETE_AMMOREADY')
						window.location.reload();
					}}>Unlink from AmmoReady</Button>}
					<Button color="danger" className='danger-button' onClick={this.handleDelete}>Delete</Button>
					<Button className="primary-button" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
			</Card>
		)
	}
}
